import * as z from 'zod'

export const addRateSchema = z.object({
  hourlyRateDollars: z
    .number({
      required_error: 'Rate is required',
      invalid_type_error: 'Must be a number',
    })
    .positive('Must be greater than 0'),
  note: z.string().optional(),
  isEnabled: z.boolean().default(true),
})

export type AddRateSchema = z.infer<typeof addRateSchema>
